import React from "react";
import MaintClone from "./MaintClone";
import MaintDetailDefault from "./MaintDetailDefault";
import MaintEdit from "./MaintEdit";
import MaintElements from "./MaintElements";
import MaintTabs from "./MaintTabs";

export default class MaintDetail extends React.Component {
  render() {
    let { mode, itemId } = this.props;
    if (itemId === "add") mode = "edit";
    return (
      <>
        {mode === "clone" && <MaintClone {...this.props} />}
        {mode === "default" && <MaintDetailDefault {...this.props} />}
        {mode === "edit" && <MaintEdit {...this.props} />}
      </>
    );
  }
}
